// removed by extract-text-webpack-plugin
module.exports = {"category-color-chart":"category-color-chart","color-chart-item":"color-chart-item"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/category-color-chart/category-color-chart.style.sass
// module id = 8xVG
// module chunks = 0